const formatPositionName = (name: string) => {
  return name.charAt(0).toUpperCase() + name.substring(1).toLowerCase();
};

export default formatPositionName;
